var _path, _rect, _rect2, _rect3, _rect4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 112,
    viewBox: "0 0 131 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M88.5525 4.67691C88.5525 4.67691 70.6474 27.3568 41.9991 13.8282C13.3509 0.299517 -15.297 36.9062 9.37195 59.1882C34.0409 81.4701 9.90051 93.7141 26.6602 107.37C45.7085 122.89 62.2919 91.4175 77.4118 98.5796C110.782 114.387 135.504 108.129 129.934 89.826C120.155 57.6973 107.652 55.6076 117.201 38.8957C126.751 22.1839 105.675 -12.5631 88.5525 4.67691Z",
    fill: "#26303E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.5312,
    y: 35.9473,
    width: 26.1439,
    height: 17.9739,
    rx: 5.8357,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9844,
    y: 39.2158,
    width: 20.4249,
    height: 2.45099,
    rx: 1.2255,
    fill: "#F9F9F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9844,
    y: 43.3008,
    width: 20.4249,
    height: 2.45099,
    rx: 1.2255,
    fill: "#F9F9F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9844,
    y: 47.3857,
    width: 10.621,
    height: 2.45099,
    rx: 1.2255,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6175_70122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2243 37.8174C58.6737 37.8174 55.0221 40.9426 55.0221 46.9155C55.0221 50.8159 56.5757 54.7888 58.9346 57.2368C59.8547 59.6848 58.1956 60.5958 57.8517 60.7255C53.09 62.4721 47.5273 65.6395 47.5273 68.7859V69.9623C47.5273 74.2504 55.6933 75.2414 63.2695 75.2414C64.9208 75.2386 66.5715 75.1763 68.2182 75.0544C66.1562 72.8779 65.0093 69.9922 65.0146 66.994C65.0146 64.2926 65.9347 61.8175 67.4641 59.8296C67.2378 59.2986 67.1474 58.4615 67.5591 57.19C69.9045 54.739 71.4249 50.8009 71.4249 46.914C71.4249 40.9426 67.7688 37.8189 63.2227 37.8189L63.2243 37.8174ZM76.799 57.4721C74.2738 57.4721 71.8521 58.4752 70.0665 60.2608C68.2809 62.0463 67.2778 64.4681 67.2778 66.9932C67.2778 69.5184 68.2809 71.9402 70.0665 73.7257C71.8521 75.5113 74.2738 76.5144 76.799 76.5144C79.3242 76.5144 81.7459 75.5113 83.5315 73.7257C85.317 71.9402 86.3201 69.5184 86.3201 66.9932C86.3201 64.4681 85.317 62.0463 83.5315 60.2608C81.7459 58.4752 79.3242 57.4721 76.799 57.4721ZM75.4792 61.7149H78.1187V65.6275H82.0313V68.3605H78.1187V72.2731H75.4792V68.3605H71.5199V65.6275H75.4792V61.7149Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6175_70122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2159,
    height: 39.2159,
    fill: "white",
    transform: "translate(47.3867 37.582)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAddress);
export default __webpack_public_path__ + "static/media/AddAddress.4c0943a6.svg";
export { ForwardRef as ReactComponent };